var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40019 2.06267C3.6 2.06267 2.19981 3.375 2.19981 5.06268C2.19981 5.25 2.2999 5.34384 2.50009 5.34384C2.6999 5.34384 2.8 5.25 2.8 5.06268C2.8 3.75 4 2.625 5.40019 2.625C5.49991 2.625 5.70009 2.53116 5.70009 2.34384C5.70009 2.15616 5.49991 2.06267 5.40019 2.06267ZM11.0002 8.53116C10.9001 8.43767 10.6999 8.43767 10.5998 8.53116L10.1001 9.09384L9.40019 8.43767C10.2999 7.5 10.8 6.375 10.8 5.06268C10.8 2.25 8.4 0 5.40019 0C2.4 0 0 2.25 0 5.06268C0 7.875 2.4 10.125 5.40019 10.125C6.8 10.125 8 9.56268 9.00018 8.81268L9.70009 9.46884L9.09991 9.93768V10.3127L13.7998 14.7188C14 14.9062 14.2002 15 14.5001 15C14.8 15 15.0002 14.9062 15.2 14.7188L15.7001 14.25C15.8999 14.0627 16 13.875 16 13.5938C16 13.3127 15.8999 13.125 15.7001 12.9377L11.0002 8.53116ZM0.600188 5.06268C0.600188 2.53116 2.69991 0.562677 5.40019 0.562677C8 0.562677 10.1998 2.53116 10.1998 5.06268C10.1998 7.5 8 9.56267 5.40019 9.56267C2.69991 9.56267 0.600188 7.5 0.600188 5.06268ZM15.3001 13.875L14.8 14.3438C14.6999 14.4377 14.5998 14.4377 14.5001 14.4377C14.4 14.4377 14.2999 14.4377 14.2002 14.3438L9.79982 10.125L10.8 9.18768L15.3001 13.3127C15.4002 13.4062 15.4002 13.5 15.4002 13.5938C15.4002 13.6877 15.4002 13.7812 15.3001 13.875Z",
    fill: "#36505E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpyIcon);
export default __webpack_public_path__ + "static/media/spy-icon.d26b15a95071c3c0efd9a83706b9fcd5.svg";
export { ForwardRef as ReactComponent };